module.exports = __webpack_public_path__ + "Roboto-Thin.ba422f71e799f3d29cbf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Thin.svg
// module id = 112
// module chunks = 10